import axios from "../../../Natus/Redux/axios";
import { data } from "jquery";
import axiosVeteriner from "../../../axios/axiosVeteriner";

export const getData = (params, dataTable = []) => {
  return async (dispatch, getState) => {
    let { page, perPage } = params;
    let token = getState().user.usertoken;
    let id = getState().petId.id;
    dataTable.data = [];
    dataTable.allData = null;
    dataTable.RefId = id;
    dataTable.rowsPerPage = 4;
    dataTable.currentPage = page === undefined ? "1" : page.toString();

    let config = {
      method: "POST",
      headers: {
        "access-control-allow-headers": "content-type",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json ",
        Authorization: "Bearer " + token,
      },
      data: dataTable,
    };
    await axios("Pet/GetPetVaccineDataList/", config)
      .then((response) => {
        dispatch({
          type: "GET_DATA",
          data: response.data.data,
          totalPages: response.data.totalPages,
          params,
        });
      })
      .catch((error) => {
        console.log(" error" + error.message);
      });
  };
};

export const getInitialData = (params, dataTable = []) => {
  return async (dispatch, getState) => {
    let { page, perPage } = params;
    let usertoken = getState().user.usertoken;
    let id = getState().petId.id;
    if (dataTable) {
      dataTable.RefId = id;
      dataTable.rowsPerPage = perPage;
      dataTable.currentPage = page;
    } else {
      dataTable.RefId = id;
    }
    let config = {
      method: "POST",
      headers: {
        "access-control-allow-headers": "content-type",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json ",
        Authorization: "Bearer " + usertoken,
      },
      data: dataTable,

    };
    await axios("Pet/GetPetVaccineDataList/", config)
      .then((response) => {
        dispatch({
          type: "GET_ALL_DATA",
          data: response.data.data,
        });
      })
      .catch((error) => {
        console.log("error" + error.message);
      });
  };
};

export const filterData = (params, dataTable = []) => {
  return (dispatch, getState) => {
    let { page, perPage } = params;
    let token = getState().user.usertoken;
    let id = getState().petId.id;
    dataTable.data = [];
    dataTable.allData = null;
    dataTable.RefId = id;
    dataTable.rowsPerPage = perPage === undefined ? 4 : parseInt(perPage);
    dataTable.currentPage =  "1";
    let config = {
      method: "POST",
      headers: {
        "access-control-allow-headers": "content-type",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json ",
        Authorization: "Bearer " + token,
      },
      data: dataTable,
    };
    axios("Pet/GetPetVaccineDataList/", config)
      .then((response) => {
        dispatch({
          type: "GET_DATA",
          data: response.data.data,
          totalPages: response.data.totalPages,
          params,
        });
      })
      .catch((error) => {
        console.log("error" + error.message);
      });
  };
};

export const deleteData = (obj) => {
  return (dispatch) => {
    axios
      .post("/api/datalist/delete-data", {
        obj,
      })
      .then((response) => {
        dispatch({ type: "DELETE_DATA", obj });
      });
  };
};

export const updateData = (obj) => {
  return async (dispatch, getState) => {
    let usertoken = getState().user.usertoken;
    let config = {
      method: "POST",
      headers: {
        "access-control-allow-headers": "content-type",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json ",
        Authorization: "Bearer " + usertoken,
      },
      data: JSON.stringify(obj),
    };

    await axios("Pet/UpdatePetVaccine", config)
      .then((response) => {
        var val = [];
        obj.de.map(
          (data, index) =>
            (val[index] = {
              id:obj.de[index].id,
              productId:obj.de[index].productId,
              quantity:1,
              deliveryAddressId:obj.de[index].deliveryAddressId,
              petVaccinesId:response.data.data.id
            })
        );
        onUpdate(val);
        dispatch({ type: "UPDATE_DATA", obj });
      })

      .catch((error) => {
        console.log("error" + error.message);
      });
  };
};

export const addData = (obj) => {
  return async (dispatch, getState) => {
    let usertoken = getState().user.usertoken;
    let config = {
      method: "POST",
      headers: {
        "access-control-allow-headers": "content-type",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json ",
        Authorization: "Bearer " + usertoken,
      },
      data: JSON.stringify(obj),
    };
    await axios("Pet/AddPetVaccine", config)
      .then((response) => {
        var val = [];
        obj.de.map(
          (data, index) =>
            (val[index] = {
              productId:obj.de[index].productId,
              quantity:1,
              deliveryAddressId:obj.de[index].deliveryAddressId,
              petVaccinesId:response.data.data.id
            })
        );
        onSubmit(val);
       })

      .catch((error) => {
        console.log("  error" + error.message);
      });
  };
};


export const onSubmit = (obj) => {
   let newMainData = JSON.stringify(obj);
   let config = {
     method: "POST",
     data: newMainData,
   };
   axiosVeteriner("PetPatientStoriesProduct/Add", config)
     .then((response) => {
      
     })
     .catch((error) => {
       const errorMsg = error.message;
       console.log("error " + errorMsg);
     });
 };
 export const onUpdate = (obj) => {
   let newMainData = JSON.stringify(obj);
   let config = {
     method: "PUT",
     data: newMainData,
   };
   axiosVeteriner("PetPatientStoriesProduct/Update", config)
     .then((response) => {
      
     })
     .catch((error) => {
       const errorMsg = error.message;
       console.log("error " + errorMsg);
     });
 };